import _ from 'underscore';
import React, { useEffect, useState } from 'react';
import { ServerEntitySelectorEmbedded } from '@bingads-webui-fluent-component/entity-selector';

import { useGoalSelectorState } from './use-goal-selector-state';
import { GoalSelectorConfigProps, GoalType } from './types';
import { fetchConversionGoalFactory } from './data';
import { TableViewSection } from './table-view-section';
import { EMPTY_STATE, Scopes } from './constants';
import { EmptyStateResultComponent } from './components/empty-state-result';

export const GoalSelector: React.FC<(GoalSelectorConfigProps)> = ({
  i18n,
  cid,
  aid,
  value: valueFromProps,
  onChange: onChangeFromProps,
  goalScopeSelection,
  isCreationWorkflow,
  activityLogger,
  campaignConversionGoal,
  ...props
}) => {
  const [scope, setScope] = useState(goalScopeSelection);
  const [emptyStateNoGoal, setEmptyStateNoGoal] = useState(false);
  const [noMainGoal, setNoMainGoal] = useState(false);

  const mainGoalPredicate = ' and (IsMainConversionGoal eq true)';
  const selectedPauseGoals = _.chain(campaignConversionGoal).get('Goals', [])
    .filter((goal: GoalType) => goal.Status === 'Paused')
    .map(goal => goal.Id)
    .value();
  const fetchData = fetchConversionGoalFactory({
    options: scope === Scopes.ACCOUNT ? { filter: mainGoalPredicate } : {},
    goalIds: scope === Scopes.ACCOUNT ? [] : selectedPauseGoals,
    cid,
    aid,
  });

  const onSetScope = (newScope) => {
    if (activityLogger && activityLogger.trace) {
      activityLogger.trace(`[GoalSelectorV3] goal scope change: ${newScope}`);
    }
    onChangeFromProps({
      goalScopeSelection: newScope,
    });

    setScope(newScope);
  };

  const onChangeGoalSelector = (items) => {
    onChangeFromProps({
      goalSelection: items,
    });
  };

  useEffect(() => {
    if (activityLogger && activityLogger.trace) {
      activityLogger.trace('[GoalSelectorV3] type: Rendered');
    }

    fetchConversionGoalFactory({ cid, aid, goalIds: selectedPauseGoals })({
      page: 1, pageSize: 5, search: '', sortState: null,
    }).then((response) => {
      if (response && response.count === 0) {
        setEmptyStateNoGoal(true);
        if (activityLogger && activityLogger.trace) {
          activityLogger.trace('[GoalSelectorV3] type: NoConversionGoal');
        }
      }
    });
    fetchConversionGoalFactory({ cid, aid, options: { filter: mainGoalPredicate } })({
      page: 1, pageSize: 5, search: '', sortState: null,
    }).then((response) => {
      if (response && response.count === 0) {
        setNoMainGoal(true);
        if (activityLogger && activityLogger.trace) {
          activityLogger.trace('[GoalSelectorV3] type: NoMainGoal');
        }
      }
    });
  }, [activityLogger, aid, cid, selectedPauseGoals]);

  const { value, onChange } = useGoalSelectorState({ value: valueFromProps, onChange: onChangeGoalSelector });
  if (emptyStateNoGoal) {
    return <div className="goal-selector-v3"> <EmptyStateResultComponent i18n={i18n} emptyState={EMPTY_STATE.NoGoalInitial} isCreationWorkflow={isCreationWorkflow} activityLogger={activityLogger} /></div>;
  }
  return (
    <>
      <ServerEntitySelectorEmbedded
        {...props}
        i18n={i18n}
        className="goal-selector-v3"
        fetchData={fetchData}
        value={value}
        onChange={onChange}
        childrenProps={
        {
          i18n,
        }
      }
      >
        <TableViewSection i18n={i18n} scope={scope} isCreationWorkflow={isCreationWorkflow} activityLogger={activityLogger} setScope={onSetScope} noMainGoal={noMainGoal} />
      </ServerEntitySelectorEmbedded>
    </>
  );
};
